<template>
   <!-- <div class="nav-buttons"> -->
      <button
         :class= "[
            btnClass,
            (this.type === 'primary') ? btnPrimClass : '',
            (this.type === 'secondary') ? btnSecndClass : '',
            this.disabled ? btnDisabled : ''
            ]"
         @click="goTo()"
         type="button"
      >
         <i v-if="this.type === 'secondary'" class="far fa-chevron-left nav-arrow right"></i>
         {{ label }}
         <i v-if="this.type === 'primary'" class="far fa-chevron-right nav-arrow left"></i>
      </button>
   <!-- </div> -->
</template>

<script>
   import { mapStates, mapGetters, mapActions } from 'vuex'
   export default {
      props: {
         type: {
            //Identifies for styling what type of button it should be
            type: String,
            validator: function (value) {
               return ['primary', 'secondary'].indexOf(value) !== -1
            },
            required: true,
         },
         label: {
            //what is the label for the button
            type: String,
            required: true,
         },
         disabled: {
            //what is the label for the button
            type: Boolean,
            required: false,
            default: false
         },
      },
      data: function(){
         //data function holding the classes for ease of use
         return {
            btnClass: 'btn-cta',
            btnPrimClass: 'btn-cta--red',
            btnSecndClass: 'btn-cta--light',
            btnDisabled: ''
         }
      },
      computed: {
      },

      methods: {
         //handles the button click
         goTo(data){
            if(!this.disabled){
               this.$emit('goTo', data);
            }
         },
      }
   }
</script>

